/* Built-in imports */
import React, { Component } from 'react';

/* Third-party imports */
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

/* Internal imports */
import KycForm from '../../../../components/US/epargne_salariale/forms/KYC/KycForm';
import { formatActionnaires } from '../../../../components/US/epargne_salariale/forms/KYC/kycMapper';
import { sendKycFields } from '../../../../services/DossierService';
import { setRetourRoute, setInformationsDossier } from '../../../../modules/tunnel/redux/tunnelActions';
import { stringToBoolean } from '../../../../common/FunctionsUtils';
import { URLS_EPARGNE } from '../../../../utils/constantes/ROUTES/EPARGNE';

class EpargneKycPage extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.props.setRetourRoute(URLS_EPARGNE.DISPOSITIF_ABONDEMENT.substring(1));

    this.state = {
      redirect: false
    };
  }

  submit(values) {
    sendKycFields(this.props.dossier.uid, this.formatKyc(values, this.props.dossier.type))
      .then((annexe) => {
        this.props.setInformationsDossier(annexe);
        this.setState({
          redirect: true
        });
      })
      .catch((error) => {
        if (error && error.message) {
          this.setState({
            errorMsg: error.message
          });
        }
      });
  }

  formatKyc(values) {
    return {
      actionnaires: formatActionnaires(values.actionnaires),
      adressePostaleEntreprise: values.isSameCompanyAddress
        ? null
        : {
          codePostal: values.adressePostaleEntrepriseCode,
          rue: values.adressePostaleEntrepriseRue,
          ville: values.adressePostaleEntrepriseVille
        },
      bonsPorteur: stringToBoolean(values.isBonsPorteur) ? values.bonsPorteur : null,
      codeBIC: stringToBoolean(values.isBanque) ? values.codeBIC : null,
      entrepriseCotee: stringToBoolean(values.isEntrepriseCotee) ? values.entrepriseCotee : null,
      paysCotation: stringToBoolean(values.isEntrepriseCotee) ? JSON.parse(values.paysCotation) : null,
      paysActivite: {
        chiffreAffaire: values.chiffreAffaire,
        pays: JSON.parse(values.pays)
      },
      paysFiscalEntreprise: JSON.parse(values.paysFiscalEntreprise),
      paysPersonneMorale: stringToBoolean(values.needPaysPersonneMorale) ? JSON.parse(values.paysPersonneMorale) : null,
      principauxMarches: values.principauxMarches,
      principauxPays: values.principauxPays,
      regulateur: stringToBoolean(values.regulateur)
        ? {
          nomRegulateur: values.nomRegulateur,
          referenceAgrement: values.referenceAgrement
        }
        : null,
      lieuExercice: {
        france: values.hasActivityFrance,
        ue: values.hasActivityUE ? values.countryActivityUE : null,
        horsUe: values.hasActivityHorsUE ? values.countryActivityHorsUE : null
      }
    };

  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={URLS_EPARGNE.TARIFICATION} />;
    }

    return (
      <div>
        <KycForm onSubmit={this.submit} />
      </div>
    );
  }
}

const mapStateToProps = ({ tunnel: { dossier } }) => ({
  dossier
});

const mapDispatchToProps = {
  setRetourRoute,
  setInformationsDossier
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EpargneKycPage);
